"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysRemaining = daysRemaining;
exports.clockStatusForDeadline = clockStatusForDeadline;
// Read-time derivation shared by the resolver and UI copy — kept separate
// from computeContainerClock so callers can re-derive status from a stored
// deadline without re-running the whole rule engine.
const date_1 = require("encamp-shared/dist/utils/date");
const types_1 = require("./rules/types");
// Positive when the deadline is in the future.
// Retaining this seemingly pointless function wrapping another function
// in one line as a single point of editing whether the clock engine
// counts days as calendar days or down-to-the-millisecond days
function daysRemaining(deadline, now) {
    return (0, date_1.utcDaysBetween)(now, deadline);
}
function clockStatusForDeadline(deadline, now, approachingWindowDays = types_1.APPROACHING_WINDOW_DAYS) {
    if (deadline === null) {
        return "NONE";
    }
    const remaining = daysRemaining(deadline, now);
    if (remaining < 0) {
        return "OVERDUE";
    }
    if (remaining <= approachingWindowDays) {
        return "APPROACHING";
    }
    return "OK";
}
//# sourceMappingURL=clockStatus.js.map